export const ROLE_ADMINISTRATOR = 'administrator';
export const ROLE_SUPERVISOR = 'administration';
export const ROLE_CUSTOMER = 'customer';
